import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AsyncThunk, unwrapResult } from '@reduxjs/toolkit';

import { resetSettingsFormState } from 'store';
import { useAppDispatch, useNotification } from 'hooks';

export const useUpdateSettings = <T>(sendUpdateRequest: AsyncThunk<T, T, {}>) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const sendNotification = useNotification();
  const [loading, setLoading] = useState(false);

  const update = useCallback(
    async (item: T) => {
      try {
        setLoading(true);
        unwrapResult(await dispatch(sendUpdateRequest(item as T & undefined)));
        sendNotification(t('success'), 'success');
        dispatch(resetSettingsFormState());
      } finally {
        setLoading(false);
      }
    },
    [dispatch, sendNotification, sendUpdateRequest, t],
  );

  return { update, loading };
};
